<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <div>
      <h6
        class="
          tx-uppercase tx-10 tx-mont tx-spacing-1
          mg-t-10
          pd-x-10
          tx-white-7
        "
      >
        {{ $t("order.条件筛选") }}
      </h6>
      <div class="mg-t-10 pd-x-10 mg-b-40">
        <div class="form-group mg-b-30">
          <select
            class="form-control form-control-dark select2 mg-b-10 select-mg"
            :data-placeholder="$t('order.订单号')"
            v-model="codeSelected"
          >
            <option :value="$t('order.订单号')">
              {{ $t("order.订单号") }}
            </option>
            <option :value="$t('order.客户系统订单号')">
              {{ $t("order.客户系统订单号") }}
            </option>
            <option :value="$t('order.发票编号')">
              {{ $t("order.发票编号") }}
            </option>
          </select>
          <input
            v-show="codeSelected == $t('order.订单号')"
            v-model="codeFilter"
            type="text"
            :placeholder="codeSelected"
            class="form-control form-control-dark tx-13"
          />
          <input
            v-show="codeSelected == $t('order.客户系统订单号')"
            v-model="filterSku"
            type="text"
            :placeholder="codeSelected"
            class="form-control form-control-dark tx-13"
          />
          <input
            v-show="codeSelected == $t('order.发票编号')"
            v-model="codeinvoicesFilter"
            type="text"
            :placeholder="codeSelected"
            class="form-control form-control-dark tx-13"
          />
        </div>
        <div class="mg-b-20 form-group">
          <div class="datepicker-group mg-b-1">
            <div class="input-group">
              <span class="input-group-addon">
                <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
              </span>
              <input
                v-model="timeCreatedFrom"
                data-id="datepicker-from"
                type="text"
                class="form-control-dark form-control fc-datepicker"
                :placeholder="$t('mall.起始日期')"
              />
            </div>
            <div class="input-group">
              <span class="input-group-addon">
                <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
              </span>
              <input
                v-model="timeCreatedTo"
                data-id="datepicker-to"
                type="text"
                class="form-control form-control-dark fc-datepicker"
                :placeholder="$t('mall.截止日期')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      class="
        btn btn-primary btn-block
        tx-uppercase tx-11 tx-spacing-2 tx-medium
      "
      @click="filtrate"
    >
      {{ $t("order.筛 选") }}
    </button>
  </div>
</template>

<script>
export default {
  props: [
    "status",
    "fCodeFilter",
    "fFilterSku",
    "fCodeinvoicesFilter",
    "fTimeCreatedFrom",
    "fTimeCreatedTo",
  ],
  data() {
    return {
      codeSelected: this.$t("order.订单号"),
      codeFilter: "",
      filterSku: "",
      codeinvoicesFilter: "",
      timeCreatedFrom: "",
      timeCreatedTo: "",
    };
  },
  watch: {
    fCodeFilter() {
      this.codeFilter = this.fCodeFilter;
    },
    fFilterSku() {
      this.filterSku = this.fFilterSku;
    },
    fCodeinvoicesFilter() {
      this.codeinvoicesFilter = this.fCodeinvoicesFilter;
    },
    fTimeCreatedFrom() {
      this.timeCreatedFrom = this.fTimeCreatedFrom;
      this.datepickerSelect();
    },
    fTimeCreatedTo() {
      this.timeCreatedTo = this.fTimeCreatedTo;
      this.datepickerSelect();
    },
  },
  mounted() {
    this.datepickerSelect();
  },
  updated() {
    $('[data-toggle="tooltip"]').tooltip();
    this.datepickerSelect();
    $(".overflow-y-auto").perfectScrollbar();
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
  methods: {
    datepickerSelect() {
      let vm = this;
      $("[data-id=datepicker-from]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-to]"))
              .datepicker("option", "minDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            vm.timeCreatedFrom = selectedDate;
          },
        });
      });
      $("[data-id=datepicker-to]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1, //显示月的数量
          dateFormat: "yy-mm-dd", //日期格式化
          onClose: function (selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-from]"))
              .datepicker("option", "maxDate", selectedDate);
          },
          onSelect: function (selectedDate) {
            vm.timeCreatedTo = selectedDate;
          },
        });
      });
    },
    filtrate() {
      this.$emit(
        "filtrate",
        this.codeFilter,
        this.filterSku,
        this.codeinvoicesFilter,
        this.timeCreatedFrom,
        this.timeCreatedTo
      );
    },
  },
};
</script>
